<template>
  <BCard>
    <!-- Page Header -->
    <div class="mb-[2rem]">
      <h1 class="text-[#333333] text-[20px] font-semibold">
        Kendala Akun
      </h1>
    </div>

    <!-- Section 1: Rekapitulasi Total Kendala -->
    <div class="mb-[1.5rem] border border-[#E2E2E2] rounded-lg p-[1.5rem]">
      <h2 class="text-[#333333] text-[18px] font-semibold">
        Rekapitulasi Total Kendala
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1rem] mt-[1rem]">
        <div
          v-for="card in summaryCards"
          :key="card.key"
          class="border border-[#E2E2E2] rounded-lg p-[1.25rem] bg-white flex flex-col justify-between min-h-[120px]"
        >
          <div>
            <div class="flex items-center gap-[0.5rem] mb-[0.75rem]">
              <div
                class="w-[24px] h-[24px] rounded flex items-center justify-center shrink-0"
                :class="card.bgColor"
              >
                <span :class="card.iconClass" />
              </div>

              <span class="text-[#626262] text-[14px] font-medium leading-none">
                {{ card.label }}
              </span>

              <span
                :id="`tooltip-${card.key}`"
                class="cursor-pointer inline-flex items-center leading-none"
              >
                <span class="k-info-circle !text-[#08A0F7] text-[16px]" />
              </span>

              <b-tooltip
                :target="`tooltip-${card.key}`"
                triggers="hover"
                :placement="card.placement || 'topLeft'"
                variant="primary"
                custom-class="long-text-tooltip"
              >
                {{ card.tooltip }}
              </b-tooltip>
            </div>

            <p class="text-[#333333] text-[30px] font-semibold leading-tight">
              {{ card.value }}
            </p>
          </div>

          <p
            v-if="card.subtitle"
            class="text-[#828282] text-[11px] italic mt-[0.5rem]"
          >
            {{ card.subtitle }}
          </p>
        </div>
      </div>
    </div>

    <!-- Section 2: Daftar Akun Terkendala -->
    <AccountIssuesTable
      ref="accountIssuesTable"
      @view-detail="handleViewDetail"
      @tab-change="getAccountIssuesStats"
    />

    <!-- Drawer Detail Kendala Akun -->
    <DrawerDetail
      id="drawer-account-issue-detail"
      :visible="showDetailDrawer"
      :detail="selectedItem"
      @on-close="handleCloseDetailDrawer"
      @resolve="handleResolveIssue"
    />

    <!-- Modal Penggantian Akun (for restricted status) -->
    <ModalChangeAccount
      id="modal-change-account-issue"
      :detail="selectedItem"
      @close="handleCloseChangeAccountModal"
      @submit="handleChangeAccountSubmit"
    />

    <!-- Unified Modal Konfirmasi -->
    <ModalConfirmation
      id="modal-confirm-account-issue"
      :loading="loadingConfirmation"
      :title="confirmationConfig.title"
      :message="confirmationConfig.message"
      :confirm-text="confirmationConfig.confirmText"
      :cancel-text="confirmationConfig.cancelText"
      @cancel="handleCloseConfirmationModal"
      @close="handleCloseConfirmationModal"
      @confirm="handleConfirmAction"
    />
  </BCard>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import AccountIssuesTable from './Table.vue'
import DrawerDetail from './DrawerDetail.vue'
import ModalConfirmation from './ModalConfirmation.vue'
import ModalChangeAccount from './ModalChangeAccount.vue'

export default {
  name: 'KendalaAkunList',
  components: {
    AccountIssuesTable,
    DrawerDetail,
    ModalConfirmation,
    ModalChangeAccount,
  },
  data() {
    return {
      showDetailDrawer: false,
      loadingConfirmation: false,
      selectedItem: {},
      confirmationConfig: {
        title: '',
        message: '',
        confirmText: 'Ya, Selesaikan',
        cancelText: 'Batal',
        actionType: '',
        formData: null,
        targetItem: null,
      },
      summaryData: {
        total_issue: 0,
        payment_issue: 0,
        on_review: 0,
        restricted: 0,
        solved: 0,
        replacement_account: 0,
      },
    }
  },
  computed: {
    summaryCards() {
      return [
        {
          key: 'total-issue',
          label: 'Total Issue',
          value: this.summaryData.total_issue || 0,
          subtitle: this.summaryData.last_updated ? `Last Updated: ${this.summaryData.last_updated}` : '',
          bgColor: 'bg-[#FFECE9]',
          iconClass: 'k-warning-2 !text-[#EA5455] text-[16px]',
          tooltip: 'Total kendala yang dihitung berdasarkan akumulasi semua Business Manager',
          placement: 'topLeft',
        },
        {
          key: 'payment-issue',
          label: 'Payment Issue',
          value: this.summaryData.payment_issue || 0,
          bgColor: 'bg-[#FEF2CD]',
          iconClass: 'k-card-remove-1 !text-[#FBBC05] text-[16px]',
          tooltip: 'Total kendala akun yang mengalami kendala pembayaran',
          placement: 'top',
        },
        {
          key: 'on-review',
          label: 'On Review',
          value: this.summaryData.on_review || 0,
          bgColor: 'bg-[#DFF3FF]',
          iconClass: 'k-clock-1 !text-[#08A0F7] text-[16px]',
          tooltip: 'Total akun yang sedang dalam proses peninjauan. Status akun dapat berubah sesuai hasil keputusan Meta',
          placement: 'topLeft',
        },
        {
          key: 'restricted',
          label: 'Restricted',
          value: this.summaryData.restricted || 0,
          bgColor: 'bg-[#FFEDED]',
          iconClass: 'k-forbidden !text-[#E31A1A] text-[16px]',
          tooltip: 'Total akun yang ditangguhkan oleh Meta',
          placement: 'topLeft',
        },
        {
          key: 'solved',
          label: 'Solved',
          value: this.summaryData.solved || 0,
          bgColor: 'bg-[#DCF3EB]',
          iconClass: 'k-profile-tick !text-[#34A770] text-[16px]',
          tooltip: 'Total akun yang telah selesai ditangani untuk kendala pembayaran',
          placement: 'topLeft',
        },
        {
          key: 'replacement-account',
          label: 'Replacement Account',
          value: this.summaryData.replacement_account || 0,
          bgColor: 'bg-[#F3E8FF]',
          iconClass: 'k-profile-2user !text-[#8B5CF6] text-[16px]',
          tooltip: 'Jumlah akun yang telah dilakukan penggantian karena mengalami penangguhan',
          placement: 'topLeft',
        },
      ]
    },
  },
  async mounted() {
    this.$store.dispatch('komadsWhitelist/fetchPendingCount')
    await this.getAccountIssuesStats()
  },
  methods: {
    /**
     * Fetch account issues stats recapitulation.
     */
    async getAccountIssuesStats() {
      const url = 'komads/api/v1/admin/whitelist_account_issues/stats'

      try {
        const res = await newAxiosIns.get(url)
        const resData = res && res.data ? res.data.data : null
        if (resData) {
          this.summaryData = {
            total_issue: resData.total_issue || 0,
            payment_issue: resData.payment_issue || 0,
            on_review: resData.on_review || 0,
            restricted: resData.restricted || 0,
            solved: resData.solved || 0,
            replacement_account: resData.replacement_account || 0,
            ...(resData.last_updated ? { last_updated: resData.last_updated } : {}),
          }
        }
      } catch {
        // Keep initial summaryData on error
      }
    },
    handleViewDetail(item) {
      this.selectedItem = item || {}
      this.showDetailDrawer = true
    },
    handleCloseDetailDrawer() {
      this.showDetailDrawer = false
    },
    handleCloseChangeAccountModal() {
      this.$bvModal.hide('modal-change-account-issue')
    },
    handleCloseConfirmationModal() {
      this.$bvModal.hide('modal-confirm-account-issue')
    },
    handleResolveIssue(item) {
      setTimeout(() => {
        this.selectedItem = item
        const issue = item

        if (issue.issue_type === 'restricted') {
          this.$bvModal.show('modal-change-account-issue')
          return
        }

        this.confirmationConfig = {
          title: 'Konfirmasi Penyelesaian Kendala Pembayaran',
          message: 'Pastikan <span class="font-semibold">kendala pembayaran</span> pada akun telah diselesaikan di <span class="font-semibold">Meta Ads Manager</span>. Tindakan ini akan menandai bahwa proses penanganan kendala telah selesai.',
          confirmText: 'Ya, Selesaikan',
          cancelText: 'Batal',
          formData: null,
          targetItem: issue,
        }
        this.$bvModal.show('modal-confirm-account-issue')
      }, 800)
    },
    handleChangeAccountSubmit(formData) {
      this.$bvModal.hide('modal-change-account-issue')
      setTimeout(() => {
        this.confirmationConfig = {
          title: 'Konfirmasi Ubah Akun Whitelisted',
          message: 'Perubahan akan langsung diterapkan di <span class="font-semibold">Partner</span>',
          confirmText: 'Ya, Ubah',
          cancelText: 'Batal',
          formData,
          targetItem: this.selectedItem,
        }
        this.$bvModal.show('modal-confirm-account-issue')
      }, 800)
    },
    async handleConfirmAction() {
      this.loadingConfirmation = true
      const target = this.confirmationConfig.targetItem || {}
      const payload = {
        payment_issue: { resolution_type: 'solved' },
        restricted: { resolution_type: 'replacement', ...this.confirmationConfig.formData },
      }

      try {
        const url = `komads/api/v1/admin/whitelist_account_issues/${target.id}/resolve`
        await newAxiosIns.put(url, payload[target.issue_type] || {})
        if (this.$toast_success) {
          this.$toast_success({
            title: 'Berhasil',
            message: target.issue_type === 'restricted' ? 'Akun berhasil diperbarui!' : 'Kendala akun berhasil diselesaikan',
          })
        }
        this.$store.dispatch('komadsWhitelist/fetchPendingCount')
        this.getAccountIssuesStats()
        if (this.$refs.accountIssuesTable) {
          this.$refs.accountIssuesTable.resetItems()
          this.$refs.accountIssuesTable.getAccountIssuesList()
        }
      } catch {
        const errorMessage = 'Gagal menyelesaikan kendala akun'
        this.$toast_error({
          title: 'Gagal',
          message: errorMessage,
        })
        return
      } finally {
        this.$bvModal.hide('modal-confirm-account-issue')
        setTimeout(() => {
          this.loadingConfirmation = false
        }, 800)
      }

      this.showDetailDrawer = false
    },
  },
}
</script>

<style scoped>
h1,
h2,
p {
  margin: 0;
}

.btn-primary {
  border-radius: 10px !important;
}
</style>
